export const en = {
  'app.name': 'hmawiw',
  'app.tagline': 'Your board, by how much you want to do things and how much energy they take.',
  'nav.board': 'Board',
  'nav.journal': 'Journal',
  'nav.settings': 'Settings',
  'nav.admin': 'Admin',
  'nav.back': 'Back',
  'nav.columns': 'Columns',
  'boards.switch': 'Switch board',
  'boards.manage': 'Manage boards',
  'boards.onScreen': 'On screen',
  'boards.nameOf': 'Name of {name}',
  'boards.up': 'Move {name} up',
  'boards.down': 'Move {name} down',
  'boards.removeOne': 'Remove {name}',
  'boards.confirmRemoveOne': 'Remove {name}?',
  'boards.shortcut': 'Change board: Alt with Up or Down',
  'boards.chip': 'Board: {name}. Tap for the list, or hold and slide up to a board.',
  'boards.hint': 'Tap the board’s name for the list, or hold it and slide up to a board.',
  'boards.manageIn': 'Manage boards in Settings',
  'settings.boards': 'Boards',
  'settings.boardsHint': 'On the phone the boards sit at the bottom in this order, one tap each; when they no longer fit, the board’s name lists them: tap it, or hold it and slide up to one. A board with open cards stays until they are moved or finished.',
  'boards.title': 'Boards',
  'boards.new': 'New board',
  'boards.namePlaceholder': 'Work, Home, Side project…',
  'boards.add': 'Add',
  'boards.remove': 'Remove',
  'boards.notEmpty': 'A board with open cards stays; move or finish them first.',
  'sheet.board': 'Board',
  'toast.movedToBoard': 'Moved to {board}',
  'column.0': 'Dreading',
  'column.1': 'Neutral',
  'column.2': 'Eager',
  'column.n': 'Level {n}',
  'band.importance.0': 'Must',
  'band.importance.1': 'Should',
  'band.importance.2': 'Could',
  'band.horizon.0': 'Today',
  'band.horizon.1': 'This week',
  'band.horizon.2': 'Whenever',
  'energy.1': 'Low',
  'energy.2': 'Medium',
  'energy.3': 'High',
  'lens.label': 'My energy',
  'lens.cycle': 'My energy: {level}. Tap to change.',
  'lens.none': 'not set',
  'lens.hint': 'Cards that ask for more than this fade. It clears itself after six hours.',
  'lens.clear': 'Clear',
  'count.cards.one': '1 card',
  'count.cards.other': '{n} cards',
  'count.boards.one': '1 board',
  'count.boards.other': '{n} boards',
  'card.energyAria': 'Needs {level} energy. Tap to change.',
  'card.open': 'Open card',
  'card.grip': 'Hold to move within the column',
  'due.today': 'Today',
  'due.tomorrow': 'Tomorrow',
  'due.inDays': 'In {n} days',
  'due.on': '{date}',
  'due.late.one': '1 day late',
  'due.late.other': '{n} days late',
  'due.lateToday': 'Overdue',
  'tag.editedElsewhere': 'Edited elsewhere',
  'sheet.title': 'Title',
  'sheet.notes': 'Notes',
  'sheet.firstStep': 'First step',
  'sheet.firstStepHint': 'The five-minute version',
  'sheet.sectionStep': 'First step & 10 minutes',
  'sheet.sectionPlan': 'Due, repeat & reminders',
  'timer.start': 'Give it 10 minutes',
  'timer.stop': 'Stop',
  'timer.left': '{time} left',
  'timer.up': '10 minutes are up: {title}',
  'timer.open': 'Open',
  'timer.dismiss': 'Dismiss',
  'timer.tried.one': 'Tried once',
  'timer.tried.other': 'Tried {n} times',
  'timer.last': 'last {when}',
  'feel.title': 'How does it feel now?',
  'feel.worse': 'Worse',
  'feel.same': 'Same',
  'feel.better': 'Better',
  'card.attempts.one': '1 attempt',
  'card.attempts.other': '{n} attempts',
  'notif.timerTitle': '10 minutes are up',
  'notif.alarmChannel': 'Alarms',
  'notif.alarmChannelHint': 'Reminders and timers set to ring',
  'reminder.ringOff': 'Notification. Tap to ring like an alarm.',
  'reminder.ringOn': 'Alarm. Tap to notify quietly.',
  'reminder.ringHint': 'The bell notifies; the alarm clock rings and vibrates.',
  'settings.timerAlert': 'End of the 10 minutes',
  'settings.timerAlertHint': 'How the end of an attempt is announced.',
  'settings.alert.notify': 'Notification',
  'settings.alert.ring': 'Alarm',
  'sheet.motivation': 'Motivation',
  'sheet.less': 'Less motivated',
  'sheet.more': 'More motivated',
  'sheet.importance': 'Band',
  'sheet.energy': 'Energy needed',
  'sheet.reminders': 'Reminders',
  'sheet.addReminder': 'Add a reminder…',
  'sheet.reminderHint': 'Reminders ring on the phone.',
  'reminder.atDue': 'At the due time',
  'reminder.before.1h': '1 hour before',
  'reminder.before.1d': '1 day before',
  'reminder.before.1w': '1 week before',
  'reminder.before.other': '{hours} hours before',
  'reminder.custom': 'At a time of my choice…',
  'reminder.add': 'Add',
  'reminder.remove': 'Remove this reminder',
  'reminder.needsDue': 'Reminders relative to the due time need a due date.',
  'reminder.noDue': 'no due date yet',
  'card.reminders': '{n} reminders',
  'notif.checkinTitle': 'How is your energy today?',
  'notif.checkinBody': 'Set it and the board fades what you cannot face.',
  'notif.digestBack': 'Back today:',
  'notif.digestQuiet': 'Gone quiet:',
  'notif.digestMore': 'and {n} more',
  'sheet.due': 'Due',
  'sheet.clearDue': 'Clear the due date',
  'sheet.done': 'Done',
  'sheet.delete': 'Delete',
  'sheet.close': 'Close',
  'sheet.cancel': 'Cancel',
  'sheet.markDone': 'Done',
  'sheet.confirmDelete': 'Delete this card?',
  'sheet.keep': 'Keep',
  'sheet.dueTime': 'Time',
  'sheet.repeat': 'Repeat',
  'repeat.never': 'Does not repeat',
  'repeat.after': 'Days after done',
  'repeat.weekly': 'Weekly',
  'repeat.monthly': 'Monthly',
  'repeat.yearly': 'Yearly',
  'repeat.ongoing': 'Ongoing, never done',
  'repeat.afterDays': 'days after it is done',
  'repeat.afterDaysAria': 'Days after done',
  'repeat.monthDay': 'Day of the month',
  'repeat.month': 'Month',
  'repeat.rhythm': 'Aim for every',
  'repeat.rhythmAria': 'Days between touches',
  'repeat.daysUnit': 'days',
  'repeat.weekdays': 'Days of the week',
  'repeat.lead': 'Show again',
  'repeat.lead.0': 'on the day',
  'repeat.lead.1': '1 day before',
  'repeat.lead.2': '2 days before',
  'repeat.lead.3': '3 days before',
  'repeat.lead.7': '1 week before',
  'repeat.lead.14': '2 weeks before',
  'repeat.lead.30': '1 month before',
  'repeat.resting': 'Resting until {date}.',
  'repeat.wake': 'Bring back now',
  'repeat.doneCount.one': 'Done once',
  'repeat.doneCount.other': 'Done {n} times',
  'repeat.touchedCount.one': 'Touched once',
  'repeat.touchedCount.other': 'Touched {n} times',
  'repeat.hint': 'Done keeps the card and moves its date on; between two dates it rests off the board.',
  'repeat.ongoingHint': 'No Done: tap when you have given it some time. Past the rhythm it turns red and joins the review.',
  'sheet.markDoneNext': 'Done for now',
  'sheet.touch': 'I gave it some time',
  'dread.why': 'Why is it dreaded?',
  'dread.unclear': 'Unclear',
  'dread.big': 'Too big',
  'dread.boring': 'Boring',
  'dread.scary': 'Scary',
  'dread.waiting': 'Waiting on someone',
  'dread.unclear.move': 'Write what the first five minutes would be.',
  'dread.unclear.action': 'Write the first step',
  'dread.big.move': 'Only the first step needs to exist today.',
  'dread.big.action': 'Write the first step',
  'dread.boring.move': 'Ten minutes with a clock is the cheapest way through boring.',
  'dread.boring.action': 'Give it 10 minutes',
  'dread.scary.move': 'Ten minutes, and then decide how it feels.',
  'dread.scary.action': 'Give it 10 minutes',
  'dread.waiting.move': 'Set a reminder to chase it and stop carrying it.',
  'dread.waiting.action': 'Add a reminder',
  'moment.lead': 'You have energy: the moment for a dreaded one.',
  'moment.open': 'Open',
  'moment.later': 'Not now',
  'pinned.lead': 'Your one dreaded thing for today',
  'pinned.unpin': 'Unpin',
  'checkin.title': 'Morning check-in',
  'checkin.energy': 'How is your energy?',
  'checkin.pick': 'One dreaded thing for today?',
  'checkin.none': 'Nothing in Dreading. Enjoy that.',
  'checkin.notToday': 'Not today',
  'card.repeats': 'Repeats',
  'card.last': 'Last {when}',
  'toast.next': 'Done. Next: {date}',
  'toast.touched': 'Noted: {title}',
  'lists.resting': 'Resting',
  'resting.hint': 'Recurring cards between two dates. Each comes back on its own, shortly before it is due.',
  'resting.empty': 'Nothing resting.',
  'resting.returns': 'Returns {date}',
  'review.quiet': 'Ongoing, gone quiet',
  'conflict.editedOn': 'Edited on {device} while you were offline.',
  'conflict.editedElsewhere': 'Edited on another device while you were offline.',
  'conflict.theirs': 'Their value: {value}',
  'conflict.useTheirs': 'Use theirs',
  'conflict.keepMine': 'Keep mine',
  'add.title': 'New card',
  'add.placeholder': 'What is it?',
  'add.column': 'Column',
  'add.submit': 'Add to {column}',
  'add.cancel': 'Cancel',
  'add.toBand': 'Add a card to {column}, {band}',
  'add.shared': 'Shared from another app',
  'add.inbox': 'Sort later',
  'add.toInbox': 'Add to the inbox',
  'inbox.title': 'Inbox',
  'inbox.count': 'Inbox · {n}',
  'inbox.sort': 'Sort',
  'inbox.hint': 'Added on the go. Give each a column; the band and the energy can wait for the card.',
  'done.empty': 'Nothing done yet. Open a card and tap Done.',
  'done.restore': 'Restore',
  'lists.done': 'Done',
  'lists.deleted': 'Deleted',
  'lists.review': 'Review',
  'lists.stats': 'Stats',
  'stats.hint': 'Computed on this device from your cards and their history. Nothing leaves it.',
  'stats.range': 'Period',
  'stats.range.4w': '4 weeks',
  'stats.range.3m': '3 months',
  'stats.range.all': 'All',
  'stats.empty': 'Nothing to count yet. History starts with this version and grows as you use the board.',
  'stats.dread': 'Does dread lie?',
  'stats.timeToDone': 'Time to Done, by column',
  'stats.timeToDoneHint': 'Days from creation to Done, by the column the card was done from.',
  'stats.done': 'Done',
  'stats.created': 'Created',
  'stats.open': 'Open',
  'stats.median': 'Median',
  'stats.p75': '3 of 4',
  'stats.dreadedRight': 'Dreaded, done from further right',
  'stats.dreadedRightHint': 'Cards that started in Dreading and were done once they had moved along.',
  'stats.moves': 'Moves along the axis',
  'stats.movesHint': 'Towards Eager and towards Dreading; undo and cancel do not count.',
  'stats.forecast': 'Easier than feared',
  'stats.forecastHint': 'Your answers after Done on a dreaded card.',
  'stats.ofN': 'of {n}',
  'stats.lever': 'Does the ten-minute lever work?',
  'stats.attempts': 'Attempts',
  'stats.attemptsHint': 'Ten-minute sessions.',
  'stats.ranStopped': 'ran out · stopped early',
  'stats.feel': 'How it felt afterwards',
  'stats.feelHint': 'Your answers to the question after the ten minutes.',
  'stats.followed': 'Followed by progress',
  'stats.followedHint': 'Attempts followed within a week by a Done or a move towards Eager.',
  'stats.momentOpened': 'High-energy offers opened',
  'stats.momentOpenedHint': 'The dreaded card offered when your energy is High.',
  'stats.momentSub': '{opened} of {shown} opened · {done} done within a day',
  'stats.morningDone': 'Morning pick done that day',
  'stats.morningDoneHint': 'The one dreaded thing chosen at the check-in.',
  'stats.dreadReasons': 'Dread, by reason',
  'stats.dreadReasonsHint': 'Cards by the reason last named, and how many moved right or got done after it.',
  'stats.cards': 'Cards',
  'stats.movedOn': 'Moved on',
  'stats.when': 'When, and at what energy?',
  'stats.byWeekday': 'Done by weekday',
  'stats.byHour': 'Done by time of day',
  'stats.byHourHint': 'Blocks of four hours, from midnight.',
  'stats.energyAtDone': 'Your energy when you did it',
  'stats.energyAtDoneHint': 'Compared with the energy the card asked for.',
  'stats.below': 'Below',
  'stats.atOrAbove': 'Enough',
  'stats.energyByHour': 'Energy you set, by time of day',
  'stats.energyByHourHint': 'Each time you set the battery in the top bar.',
  'stats.keepingUp': 'Am I keeping up?',
  'stats.perWeek': 'Done and created per week',
  'stats.perWeekHint': 'Weeks start on Monday.',
  'stats.openAge': 'Open cards by age',
  'stats.openAgeHint': 'How long the open cards have been waiting.',
  'stats.age.week': 'Under a week',
  'stats.age.month': '1 to 4 weeks',
  'stats.age.quarter': '1 to 3 months',
  'stats.age.older': 'Older',
  'stats.late': 'Done late',
  'stats.lateHint': 'Among cards that had a due date.',
  'stats.recurring': 'Recurring, on time',
  'stats.recurringHint': 'Occurrences done before their date.',
  'stats.ongoing': 'Ongoing, in rhythm',
  'stats.ongoingHint': 'Gaps between touches that stayed within the rhythm.',
  'stats.timeToDoneBand': 'Time to Done, by band',
  'stats.timeToDoneBandHint': 'By the importance band the card was done from.',
  'stats.timeToDoneEnergy': 'Time to Done, by energy',
  'stats.timeToDoneEnergyHint': 'By the energy the card asked for.',
  'stats.deleted': 'Thrown away rather than done',
  'stats.deletedHint': 'Deleted cards against Dones over the period; a restored card does not count.',
  'stats.deletedSub': '{deleted} deleted · {done} done',
  'stats.trend': 'Against the period before',
  'stats.trendHint': 'This {period} next to the {period} before it.',
  'stats.now': 'Now',
  'stats.before': 'Before',
  'stats.deletedRow': 'Deleted',
  'stats.movesRightRow': 'Moves towards Eager',
  'lists.tabs': 'Lists',
  'review.hint': 'A weekly look at what deserves a decision: overdue, important but unwanted, or forgotten.',
  'review.overdue': 'Overdue',
  'review.stuck': 'Important, not wanted',
  'review.stale': 'Untouched for two weeks',
  'review.empty': 'Nothing to review. Enjoy the week.',
  'review.added': 'Added {when}',
  'review.touched': 'Last change {when}',
  'deleted.title': 'Recently deleted',
  'deleted.hint': 'Restorable for {n} days after deletion, from any device.',
  'deleted.empty': 'Nothing deleted lately.',
  'toast.movedTo': 'Moved to {column}',
  'toast.deleted': 'Card deleted',
  'toast.done': 'Done: {title}',
  'toast.undo': 'Undo',
  'toast.doneForecast': 'Done: {title}. Than feared, it was…',
  'forecast.easier': 'Easier',
  'forecast.worse': 'Worse',
  'tour.title': 'Tour of the board',
  'tour.progress': 'Step {n} of {total}',
  'tour.next': 'Next',
  'tour.back': 'Back',
  'tour.skip': 'Skip the tour',
  'tour.remove': 'Remove the example cards',
  'tour.keep': 'Keep them',
  'tour.step.columns': 'Columns are how much you want to do something: Dreading on the left, Neutral in the middle, Eager on the right. Move a card by dragging it, or on the phone by swiping it sideways.',
  'tour.step.bands': 'Every column has three bands, Must, Should and Could. Drag a card up or down to reorder; on the phone, hold its grip.',
  'tour.step.energy': 'The battery on a card is the energy it takes: one, two or three segments. Tap it to change. Try it on this example.',
  'tour.step.battery': 'This is your energy right now. Tap it to choose a level; the cards that ask for more fade without disappearing. It clears itself after six hours.',
  'tour.step.add': 'Each band has its own +: the new card starts in that column and band. A title is enough; open the card later for the rest.',
  'tour.step.finish': 'That is all there is to it. The three example cards can go now, or stay for you to play with.',
  'tour.example.1': 'Call the dentist',
  'tour.example.2': 'Plan the weekend hike',
  'tour.example.3': 'Sort the photo folder',
  'tour.exampleNote': 'An example card from the tour.',
  'tour.exampleStep': 'Find the phone number',
  'settings.tour': 'Tour of the board',
  'settings.tourStart': 'Show it again',
  'settings.title': 'Settings',
  'settings.board': 'Board',
  'settings.bandPreset': 'Bands',
  'settings.bandPreset.importance': 'Importance',
  'settings.bandPreset.horizon': 'Horizon',
  'settings.bandPresetHint': 'Importance: Must, Should, Could, placed by hand. Horizon: Today, This week, Whenever, placed by due date; moving a card sets its date.',
  'settings.columnNames': 'Column names',
  'settings.columns': 'Columns',
  'settings.columnsHint': 'Two to six, least wanted on the left to most wanted on the right. Cards keep their place on the new scale.',
  'settings.fewerColumns': 'One column fewer',
  'settings.moreColumns': 'One column more',
  'settings.bandNames': 'Band names',
  'settings.resetLabels': 'Use the default names',
  'settings.preferences': 'Preferences',
  'settings.language': 'Language',
  'settings.language.auto': 'Automatic',
  'settings.timeFormat': 'Time format',
  'settings.timeFormat.auto': 'Automatic',
  'settings.timeFormat.12h': '12-hour',
  'settings.timeFormat.24h': '24-hour',
  'admin.defaultLocale': 'Default language',
  'admin.defaultTimeFormat': 'Default time format',
  'admin.defaultsHint': 'For users whose own preference is set to Automatic.',
  'settings.theme': 'Theme',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.accent': 'Accent colour',
  'accent.teal': 'Teal',
  'accent.blue': 'Blue',
  'accent.indigo': 'Indigo',
  'accent.violet': 'Violet',
  'accent.plum': 'Plum',
  'accent.rose': 'Rose',
  'accent.slate': 'Slate',
  'install.title': 'Install as an app',
  'install.hint': 'Its own window and an icon in your launcher; notifications included.',
  'install.button': 'Install',
  'install.installed': 'You are in the installed app.',
  'install.manual': 'Use your browser’s Install option, in its menu or address bar. Firefox needs the “Progressive Web Apps for Firefox” extension.',
  'push.title': 'Notifications in this browser',
  'push.hint': 'Reminders and the daily check-in, delivered by the browser even when hmawiw is closed.',
  'push.unsupported': 'This browser cannot receive notifications from websites.',
  'push.denied': 'Notifications are blocked for this site in the browser settings.',
  'push.error': 'Could not turn notifications on: {message}',
  'push.testTitle': 'Check that they arrive',
  'push.test': 'Send a test notification',
  'push.testSent': 'Sent. It should appear within a few seconds.',
  'push.testFailed': 'The push service refused it. Turn notifications off and on again.',
  'settings.checkin': 'Daily check-in',
  'settings.checkinHint': 'Asks for your energy every day at that time, on the phone and in browsers with notifications on.',
  'settings.checkinOff': 'Off',
  'notif.todayChannel': 'Today',
  'notif.todayChannelHint': 'Your cards for today, kept in the shade',
  'notif.todayDone': 'Done',
  'settings.todayShade': 'Today in the notification shade',
  'settings.todayShadeHint': 'One quiet notification per card overdue, due today or Must, across your boards, with a Done button. Kept up to date while the app runs, and about every quarter of an hour while it is closed.',
  'settings.on': 'On',
  'settings.off': 'Off',
  'settings.about': 'About',
  'settings.version': 'Version {version}',
  'settings.build': 'Build',
  'settings.storage': '{n} cards on this device',
  'settings.apk': 'Download the Android app',
  'settings.apkHint': 'Version {version} ({code}) · {build} · {size} MB',
  'settings.apkUpdate': 'Update the Android app',
  'settings.apkCurrent': 'Android app up to date',
  'settings.versionCode': 'Version {version} ({code})',
  'settings.noApk': 'No Android build is available yet.',
  'account.title': 'Account',
  'account.signedInAs': 'Signed in as {username}',
  'account.changePassword': 'Change password',
  'account.email': 'Email address',
  'account.emailHint': 'Where a password reset link is sent. Nothing else.',
  'account.emailPlaceholder': 'you@example.org',
  'account.emailInvalid': 'That is not an email address.',
  'account.signOut': 'Sign out on this device',
  'account.signOutPending': '{n} changes are not synced yet. Sign out anyway?',
  'account.confirm': 'Sign out',
  'devices.title': 'Devices',
  'devices.thisDevice': 'This device',
  'devices.lastSeen': 'Last seen {when}',
  'devices.revoke': 'Sign out',
  'devices.unavailable': 'Devices are listed when the server can be reached.',
  'sync.idle': 'Synced',
  'sync.syncing': 'Syncing',
  'sync.offline': 'Offline',
  'sync.offlinePending': 'Offline, {n} changes waiting',
  'sync.error': 'Sync failed, retrying',
  'sync.signedOut': 'Not signed in',
  'sync.now': 'Sync now',
  'sync.live': 'Synced, live',
  'update.web': 'A new version is ready: {current} → {next}.',
  'update.reload': 'Reload',
  'update.apk': 'Android app update: {current} → {version} ({code}).',
  'update.get': 'Update',
  'update.dismiss': 'Not now',
  'update.downloading': 'Downloading the update, {pct}%',
  'update.installing': 'Opening the installer.',
  'update.downloaded': 'The update is downloaded.',
  'update.install': 'Install',
  'update.allowInstall': 'Allow hmawiw to install apps on the screen that opened, then tap Update again.',
  'update.failed': 'The download failed. Tap Update to try again.',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.device': 'This device',
  'auth.deviceHint': 'A name you will recognise in the device list, like "Pixel 8" or "Work laptop".',
  'auth.signIn': 'Sign in',
  'auth.working': 'One moment',
  'auth.setupTitle': 'Create the admin account',
  'auth.setupHint': 'This server has no accounts yet. The first one is the admin.',
  'auth.create': 'Create the account',
  'auth.registerTitle': 'Create your account',
  'auth.inviteHint': 'You were invited to this board.',
  'auth.registerLink': 'Create an account',
  'auth.registerClosed': 'Got an invite link? Open it to create your account.',
  'forgot.link': 'Forgot your password?',
  'forgot.title': 'Reset your password',
  'forgot.hint': 'If the account has an email address, a link to choose a new password will be sent there.',
  'forgot.send': 'Send the link',
  'forgot.sent': 'If that account has an email address, a message is on its way. The link works for an hour.',
  'forgot.back': 'Back to sign in',
  'reset.title': 'Choose a new password',
  'reset.done': 'Password changed. Sign in with it.',
  'reset.invalid': 'This link is no longer valid. Ask for a new one.',
  'auth.haveAccount': 'Already have an account? Sign in',
  'auth.serverOffline': 'The server cannot be reached right now.',
  'auth.error.BAD_CREDENTIALS': 'Wrong username or password.',
  'auth.error.RATE_LIMITED': 'Too many attempts. Wait a few minutes.',
  'auth.error.DISABLED': 'This account is disabled.',
  'auth.error.USERNAME_TAKEN': 'That username is taken.',
  'auth.error.INVITE_INVALID': 'This invite link is no longer valid.',
  'auth.error.REGISTRATION_CLOSED': 'Sign-ups are closed. Ask for an invite link.',
  'auth.error.ALREADY_SETUP': 'This server already has an admin. Sign in instead.',
  'auth.error.VALIDATION': 'Username: 3 to 32 lowercase letters, digits, dot, dash or underscore. Password: 10 characters or more.',
  'auth.error.generic': 'Something went wrong. Try again.',
  'password.title': 'Choose a new password',
  'password.forced': 'Your password was set by an admin. Choose your own to continue.',
  'password.current': 'Current password',
  'password.next': 'New password',
  'password.confirm': 'Confirm the new password',
  'password.mismatch': 'The two passwords differ.',
  'password.save': 'Save the new password',
  'password.saved': 'Password changed. Your other devices were signed out.',
  'admin.title': 'Admin',
  'admin.users': 'Users',
  'admin.invites': 'Invite links',
  'admin.settings': 'Parameters',
  'admin.cardsNote': 'Cards are never listed here. Admins manage accounts, not boards.',
  'admin.newUser': 'Create a user',
  'admin.role': 'Role',
  'admin.role.admin': 'admin',
  'admin.role.user': 'user',
  'admin.tempPassword': 'Temporary password',
  'admin.tempPasswordHint': 'Leave empty to generate one. They must change it at first sign-in.',
  'admin.tempPasswordShown': 'Temporary password for {username}: {password}. It is shown once.',
  'admin.create': 'Create user',
  'admin.resetPassword': 'Reset password',
  'admin.makeAdmin': 'Make admin',
  'admin.makeUser': 'Make user',
  'admin.disable': 'Disable',
  'admin.enable': 'Enable',
  'admin.status.active': 'active',
  'admin.status.disabled': 'disabled',
  'admin.status.mustChange': 'must change password',
  'admin.created': 'Created',
  'admin.lastSignIn': 'Last sign-in',
  'admin.never': 'never',
  'admin.devices': 'Devices',
  'admin.you': 'you',
  'admin.newInvite': 'New link',
  'admin.inviteValid': 'valid {n} days',
  'admin.copy': 'Copy link',
  'admin.copied': 'Link copied',
  'admin.revoke': 'Revoke',
  'admin.inviteUsed': 'Used by {name}',
  'admin.inviteExpires': 'Expires {when}',
  'admin.inviteRevoked': 'Revoked',
  'admin.inviteExpired': 'Expired',
  'admin.inviteNew': 'New link, copy it now: {url}',
  'admin.noInvites': 'No invite links yet.',
  'admin.appTitle': 'Application title',
  'admin.registration': 'Who can create an account',
  'admin.registration.closed': 'Admin and invite links only',
  'admin.registration.open': 'Anyone with the address',
  'admin.inviteExpiry': 'Invite links stay valid for',
  'admin.tombstone': 'Keep deleted cards for',
  'admin.days': 'days',
  'admin.tombstoneHint': 'Lets devices that were offline learn about the deletion.',
  'admin.defaultColumns': 'Column names for new accounts',
  'admin.defaultBands': 'Band names for new accounts',
  'admin.apk': 'Offer the Android app for download',
  'admin.save': 'Save parameters',
  'admin.saved': 'Parameters saved',
  'admin.stats': 'Numbers',
  'admin.stats.users': 'Accounts',
  'admin.stats.cards': 'Open cards, all users',
  'admin.stats.db': 'Database',
  'admin.stats.purge': 'Last purge',
  'admin.stats.version': 'Version',
  'admin.error': 'That did not work: {message}',
  'server.title': 'Which server?',
  'server.hint': 'This phone needs the address of your hmawiw server.',
  'server.label': 'Server address',
  'server.check': 'Connect',
  'server.unreachable': 'No hmawiw server answers at that address.',
  'server.current': 'Server: {url}',
  'server.change': 'Change',
  'common.loading': 'Loading',
  'common.cancel': 'Cancel',
} as const;

export type TKey = keyof typeof en;
/** Every locale must define every key; the type makes a missing one a build error. */
export type Dictionary = Record<TKey, string>;
